import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { fulfillmentEventsAdminRouter } from './routing/fulfillmentEventsAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import {
  fulfillmentEventsApprovalRequestsAccessControl,
  fulfillmentEventsViewAccessControl,
} from './access-control/fulfillmentEventsAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'fulfillment-events',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'fulfillment-events-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    admin: [fulfillmentEventsAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV2: AdminNavEntryPointV2.Operations,
      subNavItems: [
        {
          route: 'app-admin-fulfillment-events-list',
          subRoutes: [
            'app-admin-fulfillment-events-add-locations',
            'app-admin-fulfillment-events-approval-request',
            'app-admin-fulfillment-events-bulk-edit-children-events',
            'app-admin-fulfillment-events-cancel-event',
            'app-admin-fulfillment-events-create-event',
            'app-admin-fulfillment-events-duplicate-event',
            'app-admin-fulfillment-events-edit-event',
            'app-admin-fulfillment-events-parent-event',
          ],
          labelId: 'fulfillmentEventsDomain.manageEvents',
          accessControl: fulfillmentEventsViewAccessControl,
        },
      ],
    },
    {
      attachToV2: AdminNavEntryPointV2.Operations,
      subNavItems: [
        {
          route: 'app-admin-fulfillment-events-approval-requests-list',
          labelId: 'fulfillmentEventsDomain.manageEventsApprovalRequests',
          accessControl: fulfillmentEventsApprovalRequestsAccessControl,
        },
      ],
    },
  ],
}

export default definition
